
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Moves",
      function () {
        return require("private-next-pages/Moves.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Moves"])
      });
    }
  